import { render } from "./ContactProfileForm.vue?vue&type=template&id=85834952&scoped=true"
import script from "./ContactProfileForm.vue?vue&type=script&lang=js"
export * from "./ContactProfileForm.vue?vue&type=script&lang=js"

import "./ContactProfileForm.vue?vue&type=style&index=0&id=85834952&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85834952"]])

export default __exports__